export const HomeworkType = {
  test: 'test',
  writing: 'writing',
} as const;
